import { render, staticRenderFns } from "./DocumentFilter.vue?vue&type=template&id=29f0fc5b&"
import script from "./DocumentFilter.vue?vue&type=script&lang=js&"
export * from "./DocumentFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports